var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("h3", { staticClass: "headline mb-0 admin-header" }, [
                    _vm._v("Worker Sessions"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", icon: "", color: "grey lighten-1" },
                      on: {
                        click: function ($event) {
                          return _vm.refresh(_vm.pagination)
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("fas fa-sync")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c("span", { staticClass: "subheading" }, [
                        _c("b", [_vm._v("Filters:")]),
                      ]),
                      _vm._v(" "),
                      _vm.showFilters
                        ? _c(
                            "v-icon",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.showFilters = !_vm.showFilters
                                },
                              },
                            },
                            [_vm._v("fal fa-chevron-up")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showFilters
                        ? _c(
                            "v-icon",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.showFilters = !_vm.showFilters
                                },
                              },
                            },
                            [_vm._v("fal fa-chevron-down")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showFilters
                    ? _c(
                        "v-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                            },
                          },
                          model: {
                            value: _vm.valid,
                            callback: function ($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid",
                          },
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs11: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Id",
                                              rules: [_vm.rules.numeric],
                                            },
                                            model: {
                                              value: _vm.id,
                                              callback: function ($$v) {
                                                _vm.id = $$v
                                              },
                                              expression: "id",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              items: _vm.organizations,
                                              label: "Organization",
                                              "item-text": "text",
                                              "item-value": "value",
                                            },
                                            model: {
                                              value: _vm.orgId,
                                              callback: function ($$v) {
                                                _vm.orgId = $$v
                                              },
                                              expression: "orgId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: "Ended",
                                              items: _vm.endedItems,
                                            },
                                            model: {
                                              value: _vm.ended,
                                              callback: function ($$v) {
                                                _vm.ended = $$v
                                              },
                                              expression: "ended",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: "Valid",
                                              items: _vm.validItems,
                                            },
                                            model: {
                                              value: _vm.validItemsFlag,
                                              callback: function ($$v) {
                                                _vm.validItemsFlag = $$v
                                              },
                                              expression: "validItemsFlag",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: "Active",
                                              items: _vm.activeItems,
                                            },
                                            model: {
                                              value: _vm.active,
                                              callback: function ($$v) {
                                                _vm.active = $$v
                                              },
                                              expression: "active",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "App Type" },
                                            model: {
                                              value: _vm.appType,
                                              callback: function ($$v) {
                                                _vm.appType = $$v
                                              },
                                              expression: "appType",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "Version" },
                                            model: {
                                              value: _vm.version,
                                              callback: function ($$v) {
                                                _vm.version = $$v
                                              },
                                              expression: "version",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { xs1: "" } }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: {
                                      onsubmit: "false",
                                      disabled: !_vm.valid,
                                    },
                                    on: { click: _vm.applyFilters },
                                  },
                                  [_vm._v("Apply")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-default",
                                    attrs: { onsubmit: "false" },
                                    on: { click: _vm.resetFilters },
                                  },
                                  [_vm._v("Reset")]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              items: _vm.workerSessions.content,
                              loading: _vm.loading,
                              headers: _vm.headers,
                              options: _vm.pagination,
                              "footer-props": {
                                "items-per-page-options": [
                                  5, 10, 15, 20, 50, 100,
                                ],
                              },
                              "server-items-length": _vm.totalItems,
                            },
                            on: {
                              "update:options": function ($event) {
                                _vm.pagination = $event
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item.startDate",
                                fn: function ({ item }) {
                                  return [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDateTime(item.startDate)
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.endDate",
                                fn: function ({ item }) {
                                  return [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.formatDateTime(item.endDate))
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.updatedDate",
                                fn: function ({ item }) {
                                  return [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDateTime(item.updatedDate)
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-actions"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }